import * as queryString from 'query-string';

import { UrlParamKeys } from '../../app/UrlParamKeys';
import { IWorkbookDetailInfo } from '../../ts/models/IWorkbookInfo';
import { AngularContextFactory } from '../factories/AngularContextFactory';
import { Helpers } from '../helpers/Helpers';
import { Module } from '../Module';
import { PublishWorkbookAction } from '../services/PublishWorkbookAction';
import { ISyncPublishResult } from './DatasourcePublishResultCtrl';

export class WorkbookPublishResultService {

  public static $inject = [
    '$rootScope',
    'PublishWorkbookAction',
    'AngularContextFactory'
  ];

  constructor(private $rootScope: ng.IRootScopeService,
              private PublishWorkbookAction: PublishWorkbookAction,
              private AngularContextFactory: AngularContextFactory) {
  }

  public handlePublishedWorkbook(workbookDetailInfo: IWorkbookDetailInfo, resultUrl: string) {
    const queryIndex = resultUrl.lastIndexOf('?');
    // so that we don't parse out the feature flags if there are no query params.
    const hashIndex = resultUrl.indexOf('#');
    let query = '';
    if (queryIndex > -1 && queryIndex > hashIndex) {
      query = resultUrl.substring(queryIndex);
    }
    // this will return an empty object if the parse goes awry.
    const search = queryString.parse(query);

    const publishResult: ISyncPublishResult = {
      isSyncAvailable: Helpers.BooleanQueryParamRegex.test(search[UrlParamKeys.SyncAvailable]),
      isSyncRunning: Helpers.BooleanQueryParamRegex.test(search[UrlParamKeys.SyncRunning]),
      remoteAgentWorkflowId: search[UrlParamKeys.RemoteAgentWorkflowId],
      publishedWithLQS: Helpers.BooleanQueryParamRegex.test(search[UrlParamKeys.PublishedWithLQS])
    };

    const publishedDatasourcesStr = search[UrlParamKeys.PublishedDataSources];
    const publishedDatasourceUrlNames = publishedDatasourcesStr ? publishedDatasourcesStr.split(',') : [];

    const publishedDatasourcesLqsStr = search[UrlParamKeys.PublishedDataSourcesWithLQS];
    const publishedDatasourceLQSUrlNames = publishedDatasourcesLqsStr ? publishedDatasourcesLqsStr.split(',') : [];

    const angularContext = this.AngularContextFactory.create(this.$rootScope.$new());

    this.PublishWorkbookAction.handlePublishedWorkbook(workbookDetailInfo, publishedDatasourceUrlNames, publishedDatasourceLQSUrlNames, publishResult, angularContext);
  }
}

Module.instance().service('WorkbookPublishResultService', WorkbookPublishResultService);
